import React, { useState, useEffect } from 'react';
import { createRoot } from "react-dom/client";
import FilterUI from "./FilterUI";
import './App.css';
import { parseFilterUrl } from './helpers/url'
import { createTopFilters } from './helpers/global'

// import _filter_data from './data';
// import _filter_form from './data-form';
function getNextPerformanceDate(event) {
  const now = Date.now() / 1000;
  let timestamps = [];

  if (event.performances) {
    timestamps = Object.values(event.performances)
      .map(ts => Number(ts))
      .filter(ts => !isNaN(ts))
      .sort((a, b) => a - b); // ascending
  }

  if (!timestamps.length && event.start_date) {
    let startTs = Number(event.start_date);
    if (!isNaN(startTs)) {
      if (startTs < 1e12) startTs *= 1000;
      return startTs;
    }

    startTs = Date.parse(event.start_date);
    if (!isNaN(startTs)) return startTs;

    return null;
  }

  if (!timestamps.length) return null;

  const next = timestamps.find(ts => ts > now);

  const nextTimestamp = next ? next : timestamps[timestamps.length - 1];

  return nextTimestamp * 1000;
}



function App() {


  let _filter_settings = parseFilterUrl(_filter_form, _filter_options);



  const filter_data = _filter_data;

  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState(filter_data);
  const [error, setError] = useState(null);
  const [streaming, setStreaming] = useState(true);
  const [offset, setOffset] = useState(_offset);
  const fetchData = () => {
    fetch(_filter_streaming.data_url + '?' + new URLSearchParams({
      offset: offset,
      limit: _limit,
    }))
      .then((res) => {
        return res.json()
      })
      .then((result) => {
        setIsLoaded(true);

        if (typeof result.success !== "undefined" && result.success === false) {
          return result;
        }

        const updatedItems = typeof (items) !== "undefined" && items.length
          ? items.concat(result)
          : result;

        const itemsWithNext = updatedItems.map(item => ({
          ...item,
          nextPerformance: getNextPerformanceDate(item)
        }));

        itemsWithNext.sort((a, b) => {
          if (!a.nextPerformance) return 1;
          if (!b.nextPerformance) return -1;
          return a.nextPerformance - b.nextPerformance;
        });

        setItems(itemsWithNext);
        return result;
      })
      .then((result) => {
        setOffset((offset) => offset + result.length);
        if (result.length !== 0 && result.length >= _limit) {
          setStreaming(true);
        } else {
          setStreaming(false);
        }
      })
      .catch(function (err) {
        console.log(`Error: ${err}`)
      });
  }

  useEffect(() => {
    if (streaming) {
      fetchData();
    }
  }, [offset]);

  if (error) {
    return "<div>Error: {error.message}</div>";

  } else {
    return (
      <>

        <FilterUI
          items={items}
          filterForm={_filter_form}
          filterSettings={_filter_settings}
          language={language}

        />
      </>
    );
  }
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App tab='home' />);
